import { HealthCheck } from '../types/healthCheck';

import { getDefaultServiceHealth } from './getDefaultHealthCheckValues';

declare const window: HealthCheck.ApiHealthWindow;
declare const global: HealthCheck.ApiHealthGlobal;

export default function getHealthCheckStatus() {
  const isServer = process.server || typeof window === 'undefined';
  const globalType = isServer ? global : window;
  return globalType?.healthCheckStatus || getDefaultServiceHealth();
}
